import { useCallback } from 'react';
import { type ButtonProps, HStack } from '@direct-frontend/components';
import { copyTextToClipboard } from '@direct-frontend/stdlib';
import IconCopy from './assets/IconCopy.react.svg';
import styles from './CopyButton.module.css';

type CopyButtonProps = {
    text: string;
    onSuccess?: () => void;
} & Partial<ButtonProps>;

export const CopyButton = (props: CopyButtonProps) => {
    const { text, onSuccess, children } = props;
    const onCopy = useCallback(() => {
        copyTextToClipboard(text);
        onSuccess?.();
    }, [text, onSuccess]);

    return (
        <button onClick={onCopy} title="Скопировать" className={styles.copyButton}>
            <HStack as="span" alignItems="center" gap="12">
                {children}
                <IconCopy />
            </HStack>
        </button>
    );
};
